export default __webpack_public_path__ + "static/overlay-wheel-d43897a5c967304686683e4aefa7f616.webp";